// extracted by mini-css-extract-plugin
export default {"ContractInsight":"_ContractInsight--qv65H","InsightsPrimary":"_InsightsPrimary--h4jCI","InsightsSecondary":"_InsightsSecondary--uZPAu"};